import { faKey } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { forgotPassword } from './actions';
import reducer from './reducer';
import saga from './saga';
import { makeSelectEmail } from './selectors';
import { creatorLanguage } from '~/../hocs/creatorLanguage';
import injectReducer from '~/../hocs/injectReducer';
import injectSaga from '~/../hocs/injectSaga';
import withI18next from '~/../hocs/_withI18next';
import FontIcomoonIcon from '~/components/FontIcomoonIcon';
import ForgotPasswordForm from '~/components/ForgotPasswordForm';
import Link from '~/components/I18nLink';
import Config from '~/config';
import { changeAccountType } from '~/containers/AccountTypeProvider/actions';
import { makeSelectAccountType } from '~/containers/AccountTypeProvider/selectors';
import { makeSelectCurrentLanguage } from '~/containers/Language/selectors';

@injectReducer({ key: 'forgotPassword', reducer })
@injectSaga({ key: 'forgotPassword', saga })
@creatorLanguage()
@withI18next()
class ForgotPasswordContainer extends React.Component {
  onSubmit = (values) =>
    new Promise((resolve, reject) => {
      this.props.forgotPassword({
        email: values.email,
        resolve,
        reject,
        currentLanguage: this.props.currentLanguage,
      });
    });

  handleTypeAccount = (accountType) => {
    this.props.changeAccountType(accountType);
  };

  render() {
    const { email, t, currentLanguage, accountType, checkIsShow } = this.props;

    return (
      <div className={`forgot-password-page ac-auth-bg-${Config.serviceType}`}>
        <div className="ac-dialog">
          <div className={`dialog-header ${Config.serviceType}`}>
            <FontAwesomeIcon icon={faKey} className="dialog-header-icon" />
            {t('Did you forget your password')}
          </div>
          <div className="dialog-body">
            {!email ? (
              <div style={{ paddingBottom: 40 }}>
                <div className="text-center" style={{ padding: '20px 55px' }}>
                  {t(
                    'Please enter your registered e-mail address and submit it We will send you the password',
                  )}
                </div>
                <ForgotPasswordForm onSubmit={this.onSubmit} {...this.props} />
              </div>
            ) : (
              <div style={{ paddingTop: 10 }}>
                <div
                  style={{ margin: 20 }}
                  className="text-center alert alert-success"
                >
                  {t('Password reset link has been sent')}
                </div>
                <div
                  className="text-center"
                  style={{ paddingTop: 20, paddingBottom: 50 }}
                >
                  <Link href="/">
                    <a
                      className={`btn btn-shadow ${Config.getPrefixContent(
                        'btn-ac-primary',
                      )} `}
                      style={{ padding: '6px 20px 6px 50px' }}
                    >
                      <span style={{ paddingRight: 30 }}>
                        {t('cancel_page5_button')}
                      </span>{' '}
                      <FontIcomoonIcon icon="icon-right-arrow" fixedWidth />
                    </a>
                  </Link>
                </div>
              </div>
            )}
          </div>
        </div>
        <style jsx global>
          {`
            .forgot-password-page {
              display: flex;
              justify-content: center;
              align-items: center;
              padding: 120px 0 250px 0;
            }
          `}
        </style>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  email: makeSelectEmail(),
  accountType: makeSelectAccountType(),
  currentLanguage: makeSelectCurrentLanguage(),
});

const mapDispatchToProps = (dispatch) => ({
  forgotPassword: (params) => {
    dispatch(forgotPassword(params));
  },
  changeAccountType: (accountType) => dispatch(changeAccountType(accountType)),
});

const Connector = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ForgotPasswordContainer);

export default Connector;
